import { zodResolver } from '@hookform/resolvers/zod';
import { useForm, type UseFormProps } from 'react-hook-form';
import {
	sandboxPromptSchema,
	type SandboxPromptSchemaProps
} from '@/schemas/sandboxPrompts/schema';

type UseAiPromptFormValidationProps = UseFormProps<SandboxPromptSchemaProps>;

export const useAiPromptFormValidation = (
	props: UseAiPromptFormValidationProps
) => {
	return useForm<SandboxPromptSchemaProps>({
		resolver: zodResolver(sandboxPromptSchema),
		...props
	});
};
